/**
 *
 * @param {string} groupId
 * @returns {string}
 */
export function getWelcomeMessageForGroup(groupId) {
  switch (Number(groupId)) {
    // General => groupId = 0
    case 0:
      return 'Welcome Back! To speed up the process, can you confirm your first and last name please?'

    // Email Campaigns => groupId = 22
    case 22:
      return "Let's see what you're eligible for. May I have your full name please so I can pull up your application?"

    // Email DNT => groupId = 25
    case 25:
      return 'Welcome Back! May I have your full name so we can have a specialist call you directly?'

    // Email Flow 1 => groupId = 16
    case 16:
      return "Let's see what you're eligible for. May I have your full name please so I can pull up your application?"

    // Email Flow 2 => groupId = 21
    case 21:
      return "Let's see what you're eligible for. May I have your full name please so I can pull up your application?"

    // Email Flow 3 => groupId = 38
    case 38:
      return "Let's see what you're eligible for. May I have your full name please so I can pull up your application?"

    // Good RX => groupId = 37
    case 37:
      return "Hi! Your results are ready! What's your full name so I can pull up your form?"

    // Left chat email => groupId = 28
    case 28:
      return "Let's see what you're eligible for. May I have your full name please so I can pull up your application?"

    // Loan 2 => groupId = 15
    case 15:
      return "Let's see what you're eligible for. May I have your full name please so I can pull up your application?"

    // Missed Appointments => groupId = 3
    case 3:
      return "Let's get you rescheduled! Can I have your first and last name please?"

    // Not in VS => groupId = 13
    case 13:
      return 'Hi! I see you were looking for information, and I want to make sure you get some help. About how much debt are you dealing with?'

    // SROI => groupId = 26
    case 26:
      return "Your results are ready!  You were matched with TurboDebt.  What's your full name so I can pull up your form?"

    case 44:
      return "Your results are ready!  You were matched with TurboDebt.  What's your full name so I can pull up your form?"

    // TEXT - Lead Cactus => groupId = 29
    case 29:
      return "Hi! Let's see if you qualify. Approximately what's the total of all of your balances?"

    // Texting-Dan => groupId = 23
    case 23:
      return "Hi! Thanks for verifying your information. It looks like we may have gotten disconnected before, when is a good time to discuss your options? We're here from 8:30am to 10:45pm EST, or do you have 5 minutes to jump on a call now? I can probably fit you in if you have a moment."

    // Verified Debt => groupId = 43
    case 43:
      return "Hi! Your results are ready! What's your full name so I can pull up your form?"

    // Email Missed Appt => groupId = 17
    case 17:
      return 'Welcome Back! May I have your full name so we can get you rescheduled?'

    // AbTasty => groupId = 47
    case 47:
      return "Hi! Your results are ready! What's your full name so I can pull up your form?"

    // Salesforce => groupId = 49
    case 49:
      return "Hi! Your results are ready! What's your full name so I can pull up your form?"

    // Default message
    default:
      return "Hi! Your results are ready! What's your full name so I can pull up your form?"
  }
}
